
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";
import KTTopbar from "@/layout/header/Topbar.vue";
import KTToolbar from "@/layout/toolbar/Toolbar.vue";
import { subheaderDisplay } from "@/core/helpers/config";

import {
  headerWidthFluid,
  headerLeft,
  asideDisplay,
} from "@/core/helpers/config";

export default defineComponent({
  name: "KTHeader",
  props: {
    title: String,
  },
  components: {
    KTTopbar,
    KTToolbar,
  },
  setup() {
    const store = useStore();

    const breadcrumbs = computed(() => {
      return store.getters.pageBreadcrumbPath;
    });

    return {
      headerWidthFluid,
      headerLeft,
      asideDisplay,
      subheaderDisplay,
      breadcrumbs,
    };
  },
});
